'use client';

import dynamic from 'next/dynamic';

export const DemoXYPad = dynamic(() => import('./DemoXYPad'));
